const title = 'Master Cloud'

export default function getPageTitle(pageTitle: any) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }

  return `${title}`
}
